import { Lender } from '@1delta/lender-registry'
import { InitMarginAddresses } from '@1delta/calldata-sdk'
import { Call } from '../../../utils/multicall'
import { getInitLensAddress } from '../../public-data/addresses/init'

export const buildInitUserCall = (
  chainId: string,
  lender: Lender,
  account: string,
): Call[] => {
  const lensContract = getInitLensAddress(chainId)
  const calls: Call[] = []

  // Query positions for legacy broker
  const legacyBroker = InitMarginAddresses.getLegacyFlashAggregator(chainId)
  if (legacyBroker) {
    calls.push({
      address: lensContract,
      name: 'getUserPositionData',
      params: [account, legacyBroker],
    })
  }

  // Query positions for current broker
  const currentBroker = InitMarginAddresses.getFlashAggregator(chainId)
  if (currentBroker) {
    calls.push({
      address: lensContract,
      name: 'getUserPositionData',
      params: [account, currentBroker],
    })
  }

  return calls
}
